


















import { Component, Prop, Vue } from 'vue-property-decorator';

import { Product } from '@/store/modules/lib';

@Component
export default class ProductDescription extends Vue {

  @Prop({ type: String, default: '' }) protected text!: string;

}

